<template>

    <div class="hot-sales-content wow animate__fadeInUpBig">
        <div class="top-text">
            <div class="top">
                <div class="title">
                    {{ $t('index.hotSales.title') }}
                </div>

                <div class="look-more-product pointer-cursor" @click="goProductPage">
                    {{ $t('index.hotSales.lookMoreButtonText') }}
                </div>

            </div>

            <div class="bottom">
                <div class="tips">
                    {{ $t('index.hotSales.tips') }}
                </div>
            </div>
        </div>

        <div class="swiper">
            <swiper :slides-per-view="5" :space-between="20" :loop="true" :autoplay="{ delay: 3000 }"
                :modules="[Autoplay, Navigation]" navigation pagination :breakpoints="breakpoints" class="mySwiper">
                <swiper-slide v-for="item in hotProduct" :key="item.id">
                    <div class="swiper-item pointer-cursor" @click="gotoDetails(item.id)">
                        <img :src="`${item.cover}`" class="slide-img" />
                        <p>{{ item.name }}</p>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>

</template>

<script setup lang="ts">

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { GetHotProductResponse } from '@/typeDefine/HttpResponseType'
import { onMounted, ref, Ref } from 'vue'
import { Action } from '@/typeDefine/CommonTypes'
import { UtilMethods } from '@/util/UtilMethods'
import { ResponseCode } from '@/http/ResponseCode'
import { router } from '@/router'
import { Api } from '@/http/Api'
import { ConstantField } from '@/constant/ConstantField'

const hotProduct: Ref<GetHotProductResponse['data']['hotProduct']> = ref([])

onMounted(() => {
    requestHotProduct()
})

const requestHotProduct: Action = async () => {
    const response: GetHotProductResponse = await Api.instance.getHotProductList()

    UtilMethods.showMessageToast(response,false)

    if(response.code === ResponseCode.OK) {
        hotProduct.value = response.data.hotProduct
    }
}

const gotoDetails: Action<[number]> = (id: number) => {
    router.push({
        name: 'productDetails',
        params: {
            id,
        }
    })
}

const goProductPage: Action = () => {
    router.push({
        name: 'products'
    })
}

const breakpoints: {
    readonly [K in number]: { readonly slidesPerView: number }
} = {
    // 小屏手机
    0: {
        slidesPerView: 1
    },
    // 中等屏幕（如平板）
    640: {
        slidesPerView: 2
    },
    // 大屏（如一般 PC）
    1024: {
        slidesPerView: 4
    },
    // 超大屏（如 2K 显示器）
    1440: {
        slidesPerView: 5
    }
}
</script>

<style lang="css" scoped>
.hot-sales-content {
    width: 87.5%;
    margin: 0 auto;
    padding-top: 50px;
    box-sizing: border-box;
}

.top-text .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.top-text .bottom {
    flex: 1;
    height: 100%;
}

.top-text .top .title {
    width: 80%;
    color: #333;
    font-size: 30px;
    border-left: 5px solid var(--primary-color);
    padding-left: 28px;
    margin-right: 20px;
}

.top-text .bottom .tips {
    margin: 30px 0;
    font-size: 14px;
    color: #6f6f6f;
}

.top-text .top .look-more-product {
    flex: 1;
    margin: 0 auto;
    text-align: center;
    padding: 15px 0;
    background-color: var(--primary-color);
    color: #fff;
    border-radius: 8px;
    border: 1px solid var(--primary-color);
    transition: all ease 0.6s;
}

.top-text .top .look-more-product:hover {
    background-color: #fff;
    color: var(--primary-color);
}

.hot-sales-content .swiper {
    margin-top: 20px;
}

.hot-sales-content .swiper .swiper-item p {
    text-align: center;
    color: var(--primary-color);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.slide-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 10px;
}

@media (max-width: 1200px) {
    .top-text .top .title {
        width: 68%;
    }
}

@media (max-width: 768px) {

    .top-text .top .look-more-product {
        padding: 10px 0;
    }

    .top-text .top .title {
        font-size: 24px;
    }

    .top-text .top .title {
        width: 60%;
    }
}

@media (max-width: 600px) {

    .top-text .top .look-more-product {
        font-size: 14px;
        padding: 8px 0;
    }

    .top-text .top .tips {
        font-size: 12px;
    }

    .top-text .top .title {
        width: 50%;
    }
}
</style>
